import { Editor } from '@tencent/alloy-editor';
import {
    IEditorEventHandler, IEditorTabstopEventProps,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/interface/editor-event.interface';

/**
 * 插入制表符事件处理类
 */
export class TabstopEventHandler implements IEditorEventHandler {
    private editor: Editor;

    // eslint-disable-next-line no-useless-constructor
    public constructor({
        editor,
    }: IEditorTabstopEventProps) {
        this.editor = editor;
    }

    public handleTabEvent(): boolean {
        this.editor.insertText('\t');
        return true;
    }
}
